<!--  云稼美食-->
<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner"/>
      </el-carousel-item>
    </el-carousel>
    <div class="food_top_bg">
      <div class="food_center">
        <img
          class="food_center_left_img"
          src="../../../static/other/ic_food_top.png"
        />
        <div class="food_center_right">
          <div class="food_center_right_title">云稼美食智慧餐饮解决方案</div>
          <div class="food_center_right_content">
            餐企将形成堂食、零售、外卖多核驱动，依靠零售、外卖带动营收实现翻倍增长的理想收入结构，在增强企业内生动力的同时，使行业生态更加均衡。每一个线下场景，汇聚到同一个流量池，统一运营与管理，餐饮经营将进入门店+线上并重的模式
          </div>
        </div>
      </div>
    </div>
    <!-- 云稼美食 -->
    <div class="food_function_bg">
      <div class="food_function_title">云稼美食</div>
      <div class="food_function_content">“堂食+外卖+电商”应用场景一体化</div>
      <div class="food_function_tabes">
        <el-tabs v-model="function_activeId" stretch>
          <el-tab-pane label="智慧餐厅" name="first">
            <div class="food_function_bottom_bg">
              <div class="food_function_bottom">
                <div class="food_function_bottom_title">
                  <img
                    class="food_function_bottom_img"
                    src="../../../static/other/ic_food_function_bottom_line.png"
                  />
                  云稼智慧餐厅解决方案
                </div>
                <div class="food_function_bottom_center_bg">
                  <div class="food_function_canteen_tabes">
                    <el-tabs
                      v-model="food_function_canteen_activeId"
                      tab-position="left"
                    >
                      <el-tab-pane
                        v-for="(item, sIndex) in foodTabes"
                        :key="sIndex"
                        :name="sIndex + ''"
                      >
                        <template slot="label">
                          <div style="width: 300px">{{ item.title }}</div>
                        </template>
                        <div class="food_function_canteen_bottom">
                          <div class="food_function_canteen_bottom_text">
                            {{ item.content }}
                          </div>
                          <img
                            :class="item.className"
                            :src="item.img"
                          />
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员堂食" name="second">
            <div class="food_function_bottom_bg">
              <div class="food_function_bottom">
                <div class="food_function_bottom_title">
                  <img
                    class="food_function_bottom_img"
                    src="../../../static/other/ic_food_function_bottom_line.png"
                  />
                  云稼会员堂食解决方案
                </div>
                <div class="food_function_bottom_center_bg">
                  <div class="food_function_dine_in">
                    <div class="food_function_dine_in_title">
                      扫码、点餐、下单、支付，顾客到店体验一体化操作流程，为商家减少门店人力支出，素端消费者消费时长的同时也提高了门店翻台率，提高整体运营效率
                    </div>
                    <div class="food_function_dine_in_bottom">
                      <div class="food_function_dine_in_bottom_item1">
                        <div class="food_function_dine_in_bottom_item_title1">
                          选择菜品
                        </div>
                        <div class="food_function_dine_in_bottom_item_content1">
                          添加了商品的分类搜索可以根据商品类别来快速选择商品，
                          优化了服务员点餐时的快捷
                        </div>
                      </div>
                      <div class="food_function_dine_in_bottom_item2">
                        <div class="food_function_dine_in_bottom_item_title2">
                          添加桌台
                        </div>
                        <div class="food_function_dine_in_bottom_item_content2">
                          自定义桌号，一桌一码扫码即可下单，顾客点单随心意，门店经营高效率
                        </div>
                      </div>
                      <div class="food_function_dine_in_bottom_item2">
                        <div class="food_function_dine_in_bottom_item_title2">
                          下单支付
                        </div>
                        <div class="food_function_dine_in_bottom_item_content2">
                          顾客手机支付，支持多种付款方式，无需服务，方便快捷
                        </div>
                      </div>
                      <div class="food_function_dine_in_bottom_item3">
                        <div class="food_function_dine_in_bottom_item_title3">
                          订单详情
                        </div>
                        <div class="food_function_dine_in_bottom_item_content3">
                          用户可以清晰的查看到自己选择的商品。以及随时增加或减少商品数量。最后的部分是订单的总金额的显示
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员外卖" name="third">
            <div class="food_function_bottom_bg">
              <div class="food_function_bottom_bg">
                <div class="food_function_bottom">
                  <div class="food_function_bottom_title">
                    <img
                      class="food_function_bottom_img"
                      src="../../../static/other/ic_food_function_bottom_line.png"
                    />
                    云稼会员外卖解决方案
                  </div>
                  <div class="food_function_bottom_center_bg">
                    <div class="food_function_take_out">
                      <div class="food_function_take_out_title">
                        为商家快速搭建专业的外卖程序，让商家拥有自己的外卖平台。点餐到配送，提供外卖一站式服务，会员外卖，建立商家自己的外卖平台
                      </div>
                      <img
                        class="food_function_take_out_img"
                        src="../../../static/other/ic_food_function_take_out_img.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员商城" name="fourth">
            <div class="food_function_bottom_bg">
              <div class="food_function_bottom_bg">
                <div class="food_function_bottom">
                  <div class="food_function_bottom_title">
                    <img
                      class="food_function_bottom_img"
                      src="../../../static/other/ic_food_function_bottom_line.png"
                    />
                    云稼会员商城解决方案
                  </div>
                  <div class="food_function_bottom_center_bg">
                    <div class="food_function_take_out">
                      <div class="food_function_take_out_title">
                        除了食堂和外卖业务，餐饮商家还可以通过云稼美食微商城将半成品或衍生品以零售方式卖给顾客，拓宽销售渠道，增加门店收入；会员商城，增加餐饮商家变现渠道
                      </div>
                      <img
                        class="food_function_store_img"
                        src="../../../static/other/ic_food_function_store_img.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员管理" name="fifth">
            <div class="food_function_bottom_bg">
              <div class="food_function_bottom">
                <div class="food_function_bottom_title">
                  <img
                    class="food_function_bottom_img"
                    src="../../../static/other/ic_food_function_bottom_line.png"
                  />
                  云稼会员管理解决方案
                </div>
                <div class="food_function_bottom_center_bg">
                  <div class="food_function_members_tabes">
                    <el-tabs
                      v-model="food_function_members_activeId"
                      tab-position="left"
                    >
                      <el-tab-pane
                        v-for="(item, sIndex) in memberTabes"
                        :key="sIndex"
                        :name="sIndex + ''"
                      >
                        <template slot="label">
                          <div style="width: 300px">{{ item.title }}</div>
                        </template>
                        <div class="food_function_members_bottom">
                          <div class="food_function_members_bottom_text">
                            {{ item.content }}
                          </div>
                          <img :class="item.className" :src="item.img" />
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 智慧餐厅 -->
    <div class="food_canteen_bg">
      <div class="food_canteen_center">
        <div class="food_canteen_left">
          <div class="food_canteen_left_title">
            智慧餐厅 以“三店一体”构建餐企私域
          </div>
          <div class="food_canteen_left_content">
            为餐企布局“堂食+外卖+商城”三店一体化经营模式，低成本将一家店变为三家店
          </div>
          <div
            class="food_canteen_left_item_title"
            id="food_canteen_left_item_title"
          >
            会员堂食
          </div>
          <div class="food_canteen_left_item_content">
            点餐、支付、营销等多唯独聚合会员权益，提升堂食用餐体验
          </div>
          <div
            class="food_canteen_left_item_title"
            id="food_canteen_left_item_title"
          >
            会员外卖
          </div>
          <div class="food_canteen_left_item_content">
            通过自建外卖平台，主导自有外卖业务，打通点餐支付、出票、配送全链路
          </div>
          <div
            class="food_canteen_left_item_title"
            id="food_canteen_left_item_title"
          >
            会员商城
          </div>
          <div class="food_canteen_left_item_content">
            通过自建商城，实现半成品或衍生品售卖，增加企业销售渠道
          </div>
        </div>
        <img
          class="food_canteen_right_img"
          src="../../../static/other/ic_food_canteen_right_img.png"
        />
      </div>
    </div>
    <!-- 会员外卖 -->
    <div class="food_take_out_bg">
      <div class="food_take_out_center">
        <img
          class="food_take_out_center_img"
          src="../../../static/other/ic_food_take_out.png"
        />
        <div class="food_take_out_right">
          <div class="food_take_out_right_title">
            会员外卖 建立商家自己的外卖平台
          </div>
          <div class="food_take_out_right_content">
            让每个餐饮商家都有自己的外卖平台，从点餐到配送，提供外卖一站式服务
          </div>
        </div>
      </div>
    </div>
    <!-- 会员商城 -->
    <div class="food_manage_bg">
      <div class="food_manage_center">
        <div class="food_manage_title">会员商城 增加餐饮商家变现渠道</div>
        <div class="food_manage_content">
          通过自有微商城 将半成品或衍生品以零售方式卖给顾客，拓宽销售渠道
        </div>
        <div class="food_manage_bottom">
          <div
            class="food_manage_bottom_item"
            v-for="(item, index) in food_manage_item"
            :key="index"
          >
            <img class="food_manage_bottom_item_img" :src="item.img" />
            <div class="food_manage_bottom_item_title">{{ item.title }}</div>
            <div class="food_manage_bottom_item_content">
              {{ item.content }}
            </div>
            <div class="food_manage_bottom_item_content">
              {{ item.content_two }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 营销 -->
    <div class="food_marketing_bg">
      <div class="food_marketing_center">
        <div class="food_marketing_left">
          <div class="food_marketing_left_title">多种营销插件 提升会员复购</div>
          <div class="food_marketing_left_content">
            裂变式营销，助力餐企引流新客、会员转化和会员复购
          </div>
        </div>
        <img
          class="food_marketing_center_img"
          src="../../../static/other/ic_food_marketing.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      function_activeId: "first",
      food_manage_item: [
        {
          img: require("../../../static/other/ic_food_manage_bottom_item_img1.png"),
          title: "店铺管理",
          content: "个性化商城门店装修",
          content_two: "触发消费者购买欲望",
        },
        {
          img: require("../../../static/other/ic_food_manage_bottom_item_img2.png"),
          title: "订单管理",
          content: "一站式店铺订单管理",
          content_two: "自定义导出各项数据",
        },
        {
          img: require("../../../static/other/ic_food_manage_bottom_item_img3.png"),
          title: "商品管理",
          content: "根据后台数据实时分析",
          content_two: "调整商品上架策略",
        },
        {
          img: require("../../../static/other/ic_food_manage_bottom_item_img4.png"),
          title: "物流管理",
          content: "多种物流自主选择",
          content_two: "高效提升物流配送效率",
        },
      ],
      food_function_canteen_activeId: "0",
      foodTabes: [
        {
          title: "搭建属私域流量平台",
          content: "以'PC+APP+小程序'为餐饮企业搭建属于自己的私域流量平台",
          img: require("../../../static/other/ic_food_function_canteen_tabes_img1.png"),
          className:"food_function_canteen_bottom_img1"
        },
        {
          title: "整合经营所需的功能",
          content:
            "整合点餐、营销、会员、外卖、商城等餐厅经营所需的功能，以'堂食+外卖+商城'三店一体的经营模式，帮助传统中小餐饮企业以低成本、高效率实现数字化转型和升级",
          img: require("../../../static/other/ic_food_function_canteen_tabes_img2.png"),
          className:"food_function_canteen_bottom_img2"
        },
        {
          title: "三店一体化的经营模式",
          content:
            "布局'堂食+外卖+商城'三店一体化的餐饮经营模式，建立属于餐饮企业自己的一体化私域流量，低成本将一家店变三家店",
          img: require("../../../static/other/ic_food_function_canteen_tabes_img3.png"),
          className:"food_function_canteen_bottom_img3"
        },
      ],

      food_function_members_activeId: "0",
      memberTabes: [
        {
          title: "勾勒会员画像，实现精准营销",
          content:
            "通过会员信息、消费行为进行会员画像，使用大数据分析，为会员定制个性化饿的营销方案，促进会员二次复购或到店转化；勾勒会员画像，实现精准营销",
          img: require("../../../static/other/ic_food_function_member_tabes_img1.png"),
          className: "food_function_members_bottom_img2",
        },
        {
          title: "裂变式营销，实现到店引流",
          content:
            "多重营销活动，助力餐饮企业快速拉新和转化。裂变式营销，实现到店引流、会员转化和会员复购",
          img: require("../../../static/other/ic_food_function_member_tabes_img2.png"),
          className: "food_function_members_bottom_img",
        },
      ],
    };
  },

  components: {},

  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height:100%; 
}
.food_top_bg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: url("../../../static/other/bg_food_top.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0;
  width: 100%;
  height: 600px;
  .food_center {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1180px;
    .food_center_left_img {
      width: 496px;
      height: 420px;
      margin-right: 160px;
    }
    .food_center_right {
      display: flex;
      flex-direction: column;
      .food_center_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
        margin-bottom: 12px;
      }
      .food_center_right_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
      }
    }
  }
}

.food_function_bg {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .food_function_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }

  .food_function_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    margin-bottom: 40px;
  }

  .food_function_tabes {
    width: 100%;

    >>> .el-tabs__header {
      margin: 0px;
    }
    >>> .el-tabs__nav-scroll {
      width: 1000px;
      margin: 0 auto;
    }
    /* 去除最底部下划线 */
    >>> .el-tabs__nav-wrap::after {
      position: static !important;
    }

    >>> .el-tabs__item {
      height: 68px;
      line-height: 68px;
      text-align: center;
      font-size: 20px;
      font-weight: 400;
      color: #333333;
    }
    /*选中样式*/
    >>> .el-tabs__item.is-active {
      height: 68px;
      line-height: 68px;
      text-align: center;
      font-size: 20px;
      color: #3370ff;
    }
    //切换tab宽度
    >>> .el-tabs__active-bar {
      height: 3px;
    }
    .food_function_bottom_bg {
      width: 100%;
      height: 643px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f3f5fa;
      .food_function_bottom {
        display: flex;
        flex-direction: column;
        width: 1180px;
        .food_function_bottom_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          color: #333333;
          display: flex;
          margin-bottom: 20px;
        }
        .food_function_bottom_img {
          width: 3px;
          height: 20px;
          margin-right: 10px;
          margin-top: 2px;
        }

        .food_function_bottom_center_bg {
          background: #ffffff;
          border-radius: 4px;
          width: 1180px;
          height: 480px;

          //   智慧餐厅
          .food_function_canteen_tabes {
            width: 100%;
            height: 480px;
            margin-left: 48px;

            >>> .el-tabs__nav-scroll {
              width: 300px;
            }
            /* 去除最底部下划线 */
            >>> .el-tabs__nav-wrap::after {
              position: static !important;
            }
            /*隐藏tab下面的一横*/
            >>> .el-tabs__active-bar {
              background-color: transparent !important;
            }
            >>> .el-tabs__nav {
              margin: 96px 0;
            }
            >>> .el-tabs__item {
              display: flex;
              justify-content: center;
              width: 300px;
              height: 80px;
              line-height: 80px;
              font-family: "PingFang SC";
              font-weight: 400;
              font-size: 16px;
              color: #333333;
              border-radius: 4px;
              border: 1px solid #ebeef5;
              background: #ffffff;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              margin-bottom: 24px;
            }
            /*选中样式*/
            >>> .el-tabs__item.is-active {
              display: flex;
              justify-content: center;
              width: 300px;
              height: 80px;
              font-family: "PingFang SC";
              font-weight: 500;
              font-size: 16px;
              color: #ffffff;
              border-radius: 4px;
              background: url("../../../static/other/bg_canteen_tab_s.png");
              margin-bottom: 24px;
            }
            .food_function_canteen_bottom {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 400px;
              margin-top: 48px;
              margin-left: 120px;
              margin-right: 80px;
              .food_function_canteen_bottom_text {
                font-family: "PingFang SC";
                width: 632px;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                color: #333333;
              }
              .food_function_canteen_bottom_img1 {
                width: 472px;
                height: auto;
                margin-top: 28px;
              }
              .food_function_canteen_bottom_img2 {
                width: 460px;
                height: auto;
                margin-top: 28px;
              }
              .food_function_canteen_bottom_img3 {
                width: 642px;
                height: auto;
                margin-top: 28px;
              }

            }
          }
          // 会员堂食
          .food_function_dine_in {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            .food_function_dine_in_title {
              font-family: "PingFang SC";
              font-weight: 400;
              font-size: 16px;
              line-height: 24px;
              text-align: center;
              color: #333333;
              width: 763px;
              margin-top: 76px;
              margin-bottom: 49px;
            }
            .food_function_dine_in_bottom {
              display: flex;
              flex-direction: row;
              width: auto;
              .food_function_dine_in_bottom_item1 {
                display: flex;
                flex-direction: column;
                background: url("../../../static/other/bg_food_function_dine_in_bottom1.png");
                width: 276px;
                height: 200px;

                .food_function_dine_in_bottom_item_title1 {
                  font-family: "PingFang SC";
                  font-weight: 500;
                  font-size: 18px;
                  line-height: 27px;
                  color: #333333;
                  margin-top: 32px;
                  margin-bottom: 12px;
                  margin-left: 94px;
                }
                .food_function_dine_in_bottom_item_content1 {
                  font-family: "PingFang SC";
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 21px;
                  color: #666666;
                  width: 200px;
                  margin-left: 32px;
                }
              }

              .food_function_dine_in_bottom_item1:hover {
                background: url("../../../static/other/bg_food_function_dine_in_bottom1_s.png");
                .food_function_dine_in_bottom_item_title1 {
                  color: #ffffff;
                }
                .food_function_dine_in_bottom_item_content1 {
                  color: #ffffff;
                }
              }

              .food_function_dine_in_bottom_item2 {
                display: flex;
                flex-direction: column;
                background: url("../../../static/other/bg_food_function_dine_in_bottom2.png");
                width: 276px;
                height: 200px;

                .food_function_dine_in_bottom_item_title2 {
                  font-family: "PingFang SC";
                  font-weight: 500;
                  font-size: 18px;
                  line-height: 27px;
                  color: #333333;
                  margin-top: 32px;
                  margin-bottom: 12px;
                  margin-left: 112px;
                }
                .food_function_dine_in_bottom_item_content2 {
                  font-family: "PingFang SC";
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 21px;
                  color: #666666;
                  width: 200px;
                  margin-left: 52px;
                }
              }
            }
            .food_function_dine_in_bottom_item2:hover {
              background: url("../../../static/other/bg_food_function_dine_in_bottom2_s.png");
              .food_function_dine_in_bottom_item_title2 {
                color: #ffffff;
              }
              .food_function_dine_in_bottom_item_content2 {
                color: #ffffff;
              }
            }

            .food_function_dine_in_bottom_item3 {
              display: flex;
              flex-direction: column;
              background: url("../../../static/other/bg_food_function_dine_in_bottom3.png");
              width: 256px;
              height: 200px;

              .food_function_dine_in_bottom_item_title3 {
                font-family: "PingFang SC";
                font-weight: 500;
                font-size: 18px;
                line-height: 27px;
                color: #333333;
                margin-top: 32px;
                margin-bottom: 12px;
                margin-left: 101px;
              }
              .food_function_dine_in_bottom_item_content3 {
                font-family: "PingFang SC";
                font-weight: 400;
                font-size: 14px;
                line-height: 21px;
                color: #666666;
                width: 200px;
                margin-left: 39px;
              }
            }
          }
          .food_function_dine_in_bottom_item3:hover {
            background: url("../../../static/other/bg_food_function_dine_in_bottom3_s.png");
            .food_function_dine_in_bottom_item_title3 {
              color: #ffffff;
            }
            .food_function_dine_in_bottom_item_content3 {
              color: #ffffff;
            }
          }
        }
        // 外卖  商城
        .food_function_take_out {
          display: flex;
          flex-direction: column;
          align-items: center;
          .food_function_take_out_title {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            color: #333333;
            margin-top: 80px;
            width: 665px;
          }
          .food_function_take_out_img {
            width: 975px;
            height: 142px;
            margin-top: 80px;
          }
          .food_function_store_img {
            width: 920px;
            height: 239px;
            margin-top: 60px;
          }
        }
        //   会员管理
        .food_function_members_tabes {
          width: 100%;
          height: 480px;
          margin-left: 48px;

          >>> .el-tabs__nav-scroll {
            width: 300px;
          }
          /* 去除最底部下划线 */
          >>> .el-tabs__nav-wrap::after {
            position: static !important;
          }
          /*隐藏tab下面的一横*/
          >>> .el-tabs__active-bar {
            background-color: transparent !important;
          }
          >>> .el-tabs__nav {
            margin: 148px 0;
          }
          >>> .el-tabs__item {
            display: flex;
            justify-content: center;
            width: 300px;
            height: 80px;
            line-height: 80px;
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            border-radius: 4px;
            border: 1px solid #ebeef5;
            background: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            margin-bottom: 24px;
          }
          /*选中样式*/
          >>> .el-tabs__item.is-active {
            display: flex;
            justify-content: center;
            width: 300px;
            height: 80px;
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            border-radius: 4px;
            background: url("../../../static/other/bg_canteen_tab_s.png");
            margin-bottom: 24px;
          }
          .food_function_members_bottom {
            display: flex;
            flex-direction: column;
            height: 400px;
            margin-top: 60px;
            margin-left: 120px;
            .food_function_members_bottom_text {
              font-family: "PingFang SC";
              width: 632px;
              font-weight: 400;
              font-size: 16px;
              line-height: 22px;
              color: #333333;
            }
            .food_function_members_bottom_img {
              width: 530px;
              margin-top: 40px;
            }
            .food_function_members_bottom_img2 {
              width: 310px;
              margin-top: 40px;
              margin-left: 130px;
            }
          }
        }
      }
    }
  }
}

.food_canteen_bg {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 630px;
  .food_canteen_center {
    display: flex;
    flex-direction: row;
    width: 1180px;
    height: auto;

    .food_canteen_left {
      display: flex;
      flex-direction: column;
      height: 100%;
      .food_canteen_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
      }
      .food_canteen_left_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        width: 463px;
        margin-top: 8px;
        margin-bottom: 60px;
      }
      .food_canteen_left_item_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-bottom: 6px;
      }
      div[id="food_canteen_left_item_title"]:before {
        content: "●";
        color: #3370ff;
      }

      .food_canteen_left_item_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
        width: 320px;
        margin-bottom: 24px;
        margin-left: 15px;
      }
    }
    .food_canteen_right_img {
      width: 605px;
      margin-left: 90px;
    }
  }
}

.food_take_out_bg {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f5fa;
  height: 600px;
  .food_take_out_center {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1180px;
    .food_take_out_center_img {
      width: 679px;
      height: 420px;
      margin-right: 70px;
    }
    .food_take_out_right {
      display: flex;
      flex-direction: column;
      height: auto;
      .food_take_out_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        text-align: center;
        color: #333333;
      }
      .food_take_out_right_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        width: 430px;
        margin-top: 12px;
      }
    }
  }
}
.food_manage_bg {
  display: flex;
  justify-content: center;
  background: #ffffff;
  height: 534px;
  .food_manage_center {
    display: flex;
    flex-direction: column;
    align-items: center;

    .food_manage_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      color: #333333;
      margin-top: 80px;
      margin-bottom: 8px;
    }
    .food_manage_content {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      margin-bottom: 100px;
    }
    .food_manage_bottom {
      display: flex;
      flex-direction: row;
      .food_manage_bottom_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 75px;
        padding-right: 75px;
        .food_manage_bottom_item_img {
          width: 76px;
          height: 76px;
        }
        .food_manage_bottom_item_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: #333333;
          margin-bottom: 8px;
        }
        .food_manage_bottom_item_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #666666;
          margin-top: 12px;
        }
      }
    }
  }
}

.food_marketing_bg {
  display: flex;
  justify-content: center;
  background: #f3f5fa;
  height: 600px;
  .food_marketing_center {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1180px;

    .food_marketing_left {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: auto;
      .food_marketing_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
      }
      .food_marketing_left_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-top: 12px;
      }
    }
    .food_marketing_center_img {
      width: 517px;
      height: 375px;
      margin-left: 200px;
    }
  }
}
</style>